export default __webpack_public_path__ + "static/飞书20210915-180123-d4cb3274333e40d41f72bf884785e3ec.png";